/**
 * Router for Project
 */
import 'nprogress/nprogress.css'

import Vue from 'vue'
import Router from 'vue-router'
import store from '../store.js'
// import NProgress from 'nprogress'
// import UIkit from 'uikit'
import _ from 'lodash'
import UIkit from 'uikit'

Vue.use(Router)

let router = new Router({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  mode: 'hash',
  base: __dirname,
  routes: [
    {
      path: '/reload',
      name: 'reload',
      meta: {requiresAuth: false, searchbar: false, bottomnav: 'full', mode: 'consumer'},
      component: () => import('@/pages/Reload.vue')
    },
    {
      path: '/',
      name: 'home',
      meta: { requiresAuth: false, searchbar: true, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/Home.vue')
    },
    {
      path: '/eula',
      name: 'eula',
      meta: { requiresAuth: false, searchbar: true, mode: 'consumer' },
      component: () => import('@/pages/Eula.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      meta: { requiresAuth: false, searchbar: false, bottomnav: false, mode: 'consumer' },
      component: () => import('@/pages/Privacy.vue')
    },
    // {
    //   path: '/home',
    //   name: 'home2',
    //   meta: { requiresAuth: true, searchbar: false, bottomnav: 'full' },
    //   component: () => import('@/pages/Home.vue')
    // },
    {
      path: '/loyalty-points',
      name: 'loyaltypoints',
      meta: { requiresAuth: true, searchbar: false, listingbar: false, bottomnav: 'full', rootSection: 'loyalty', mode: 'consumer' },
      component: () => import('@/pages/LoyaltyPoints.vue')
    },
    // Loyalty
    {
      path: '/loyalty',
      name: 'loyalty',
      meta: { requiresAuth: false, searchbar: true, listingbar: true, bottomnav: 'full', rootSection: 'loyalty', mode: 'consumer' },
      component: () => import('@/pages/Loyalty.vue')
    },
    {
      path: '/loyalty/type',
      name: 'loyaltytype',
      meta: { requiresAuth: true, searchbar: true, listingbar: true, bottomnav: 'full', rootSection: 'loyalty', mode: 'consumer' },
      component: () => import('@/pages/LoyaltyType.vue')
    },
    {
      path: '/loyalty/map',
      name: 'loyaltymap',
      meta: { requiresAuth: true, searchbar: true, listingbar: true, bottomnav: 'full', rootSection: 'loyalty', mode: 'consumer' },
      component: () => import('@/pages/LoyaltyMap.vue')
    },
    {
      path: '/loyalty/:id/location/:location_id',
      name: 'loyaltysingle',
      meta: { requiresAuth: true, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/LoyaltySingle.vue')
    },
    {
      path: '/loyalty/:id/location/:location_id/reward/:reward_id',
      name: 'loyaltysingle',
      meta: { requiresAuth: true, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/LoyaltySingle.vue')
    },
    {
      path: '/loyalty/:id/location/:location_id/map',
      name: 'loyaltysinglemap',
      meta: { requiresAuth: true, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/LoyaltySingleMap.vue')
    },
    // Locations
    {
      path: '/locations',
      name: 'locations',
      meta: { requiresAuth: false, searchbar: true, listingbar: true, bottomnav: 'full', rootSection: 'locations', mode: 'consumer' },
      component: () => import('@/pages/Locations.vue')
    },
    {
      path: '/locations/type',
      name: 'locationstype',
      meta: { requiresAuth: false, searchbar: true, listingbar: true, bottomnav: 'full', rootSection: 'locations', mode: 'consumer' },
      component: () => import('@/pages/LocationsType.vue')
    },
    {
      path: '/locations/map',
      name: 'locationsmap',
      meta: { requiresAuth: false, searchbar: true, listingbar: true, bottomnav: 'full', rootSection: 'locations', mode: 'consumer' },
      component: () => import('@/pages/LocationsMap.vue')
    },
    {
      path: '/locations/:id',
      name: 'locationsingle',
      meta: { requiresAuth: false, locationSingleRegion: false, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/LocationSingle.vue')
    },
    {
      path: '/locations-by-region/:id',
      name: 'locationbyregion',
      meta: { requiresAuth: false, locationSingleRegion: true, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/LocationSingle.vue')
    },
    // Coupons
    {
      path: '/coupons',
      name: 'coupons',
      meta: { requiresAuth: false, searchbar: true, listingbar: true, bottomnav: 'full', rootSection: 'coupons', mode: 'consumer' },
      component: () => import('@/pages/Coupons.vue')
    },
    {
      path: '/coupons/type',
      name: 'couponstype',
      meta: { requiresAuth: true, searchbar: true, listingbar: true, bottomnav: 'full', rootSection: 'coupons', mode: 'consumer' },
      component: () => import('@/pages/CouponsType.vue')
    },
    {
      path: '/coupons/map',
      name: 'couponsmap',
      meta: { requiresAuth: true, searchbar: true, listingbar: true, bottomnav: 'full', rootSection: 'coupons', mode: 'consumer' },
      component: () => import('@/pages/CouponsMap.vue')
    },
    {
      path: '/coupons/:id/location/:location_id',
      name: 'couponsingle',
      meta: { requiresAuth: true, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/CouponSingle.vue')
    },
    {
      path: '/coupons/:id/location/:location_id/map',
      name: 'couponsinglemap',
      meta: { requiresAuth: true, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/CouponSingleMap.vue')
    },
    // Profile
    {
      path: '/profile',
      name: 'profile',
      meta: { requiresAuth: true, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/Profile.vue')
    },
    {
      path: '/login',
      name: 'login',
      meta: { layout: 'guest', guest: true, mode: 'consumer' },
      component: () => import('@/pages/Login.vue')
    },
    {
      path: '/login/:return',
      name: 'loginret',
      meta: { layout: 'guest', guest: true, mode: 'consumer' },
      component: () => import('@/pages/Login.vue')
    },
    {
      path: '/login/:return/:returnid',
      name: 'loginretid',
      meta: { layout: 'guest', guest: true, mode: 'consumer' },
      component: () => import('@/pages/Login.vue')
    },
    {
      path: '/register',
      name: 'register',
      meta: { layout: 'guest', guest: true, mode: 'consumer' },
      component: () => import('@/pages/Register.vue')
    },
    {
      path: '/register/:return',
      name: 'registerret',
      meta: { layout: 'guest', guest: true, mode: 'consumer' },
      component: () => import('@/pages/Register.vue')
    },
    {
      path: '/register/:return/:returnid',
      name: 'registerretid',
      meta: { layout: 'guest', guest: true, mode: 'consumer' },
      component: () => import('@/pages/Register.vue')
    },
    {
      path: '*',
      name: '404*',
      meta: { layout: 'guest', guest: true, mode: 'consumer' },
      component: require('@/pages/404.vue').default
    },
    // Merchant
    {
      path: '/login-merchant',
      name: 'loginmerchant',
      meta: { layout: 'guest', guest: true, mode: 'merchant' },
      component: () => import('@/pages/LoginMerchant.vue')
    },
    {
      path: '/merchant',
      name: 'merchant',
      meta: { layout: 'merchant', requiresAuth: true, guest: true, mode: 'merchant' },
      component: () => import('@/pages/MerchantHome.vue')
    },
    // Subscription
    {
      path: '/subscription',
      name: 'subscription',
      meta: { requiresAuth: true, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/Subscription.vue')
    },
    // E-Gift Cards
    {
      path: '/gift-cards',
      name: 'gift-cards',
      meta: { requiresAuth: true, bottomnav: 'full', searchbar: true, giftcardbar: true, rootSection: 'gift-cards', mode: 'consumer' },
      component: () => import('@/pages/GiftCards/GiftCards.vue')
    },
    {
      path: '/gift-cards/received',
      name: 'gift-cards-received',
      meta: { requiresAuth: true, bottomnav: 'full', searchbar: true, giftcardbar: true, rootSection: 'gift-cards', mode: 'consumer' },
      component: () => import('@/pages/GiftCards/GiftCardsReceived.vue')
    },
    {
      path: '/gift-cards/spent',
      name: 'gift-cards-spent',
      meta: { requiresAuth: true, bottomnav: 'full', searchbar: true, giftcardbar: true, rootSection: 'gift-cards', mode: 'consumer' },
      component: () => import('@/pages/GiftCards/GiftCardsSpent.vue')
    },
    {
      path: '/gift-cards/purchase',
      name: 'gift-card-purchase',
      meta: { requiresAuth: false, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/GiftCards/BuyGiftCard.vue')
    },
    {
      path: '/gift-cards/:id/redeem',
      name: 'gift-card-redemption',
      meta: { requiresAuth: false, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/GiftCards/RedeemGiftCard.vue')
    },
    {
      path: '/gift-cards/:id/accept',
      name: 'gift-card-accept',
      meta: { requiresAuth: false, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/GiftCards/AcceptGiftCard.vue')
    },
    {
      path: '/gift-cards/:id',
      name: 'gift-card-single',
      meta: { requiresAuth: false, bottomnav: 'full', mode: 'consumer' },
      component: () => import('@/pages/GiftCards/GiftCardSingle.vue')
    }
  ]
})
// @todo: modify for our liking this is boilerplate here.
router.beforeEach((to, from, next) => {
  // Adding a 500ms delay to prevent bleed through of the click
  // Determine app mode
  let appModeOverride = _.get(store.getters.appConfig, 'app_mode_override', false)
  console.log(appModeOverride)
  setTimeout(function () {
    if ((store.getters.appMode === 'merchant' || appModeOverride === 'merchant') && to.meta.mode !== 'merchant') {
      if (!store.getters.isLoggedIn) {
        next('/login-merchant')
      }
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (store.getters.appMode === 'consumer') {
        if (store.getters.isLoggedIn) {
          // Want to make sure we have initial data
          if (!store.getters.isInitialAjaxDone) {
            store.dispatch('requestLocation')
              .then()
              .catch(err => console.log(err))
          }
          next()
          return
        }
      } else if (store.getters.appMode === 'merchant') {
        next()
        return
      }
      if (_.has(store.getters.appConfig, 'auto_login') &&
          _.has(store.getters.appConfig, 'auto_login.username') &&
          _.has(store.getters.appConfig, 'auto_login.password')) {
        let username = _.get(store.getters.appConfig, 'auto_login.username')
        let password = _.get(store.getters.appConfig, 'auto_login.password')
        store.dispatch('login', {username, password})
          .then(function (something) {
            next()
          })
          .catch(function (err) {
            UIkit.notification({message: 'Username or password are incorrect', status: 'error'})
            console.log(err)
          })
      } else {
        next('/login')
      }
    } else {
      if (_.has(store.getters.appConfig, 'auto_login') &&
        _.has(store.getters.appConfig, 'auto_login.username') &&
        _.has(store.getters.appConfig, 'auto_login.password')) {
        let username = _.get(store.getters.appConfig, 'auto_login.username')
        let password = _.get(store.getters.appConfig, 'auto_login.password')
        store.dispatch('login', {username, password})
          .then(function (something) {
            next()
          })
          .catch(function (err) {
            UIkit.notification({message: 'Username or password are incorrect', status: 'error'})
            console.log(err)
          })
      } else {
        next()
      }
    }
  }, 500)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js